import { useEffect } from 'react';

import { useOnceReveal } from '@common/hooks';
import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

import { useShopLog } from './useShopLog';

export const useSendPageViewLog = () => {
  const { targetRef, isRevealed } = useOnceReveal();

  const { impressionStory } = useShopLog();
  const params = useCatalogProductIdParams();
  const { product, shop, isFetched } = usePdpBaseInfo(params);

  useEffect(() => {
    if (isRevealed && isFetched) {
      impressionStory(product.id, shop.id);
    }
  }, [isRevealed, isFetched]);

  return { targetRef };
};
